import { BaseIcon } from "./baseIcon";

export const eyeIcon = (
  <BaseIcon
    pathData="M15 12a3 3 0 11-6 0 3 3 0 016 0z M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
    size="w-3.5 h-3.5"
  />
);
